export const isValidFilterLabels = (arr: string[]): boolean => {
  if (arr?.length < 2) return false;

  const isFirstEntered = arr[0] !== "";
  const isSecondEntered = arr[1] !== "";

  return isFirstEntered && (arr[1] === "" || isSecondEntered);
};
